export interface PrivacyPageData {}

export interface PrivacyPageProps extends PrivacyPageData {}
